import React, { useRef, useState } from 'react'
import { useEffect } from 'react';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import './Cashflow.css'
import { Toast } from 'primereact/toast'
import { Api } from '../../../services/api';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import { CommonService } from '../../../services/commonService';
import { Button } from 'primereact/button';
import { FaFileExcel } from 'react-icons/fa';
import { IoMdRefresh } from "react-icons/io";

const Cashfloww = () => {
  const toast = useRef(null);
  const [projects, setProjects] = useState([]);
  const [columnName, setColumnName] = useState([]);
  const [RowName, setRowName] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState([]);
  const [yearList, setYearlist] = useState([]);
  const [startYear, setStartYear] = useState(2023);
  const [endYear, setEndYear] = useState(2024);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectOnStartDate, setSelectOnStartDate] = useState('2025-01-01')
  const [selectOnEndDate, setSelectOnEndDate] = useState('2025-12-31')

  useEffect(() => {
    getProject();
    selectDate()

  }, []);

  //API call to get projects  
  const getProject = () => {
    setIsLoading(true);

    var _body = {
      start_year: startYear,
      end_year: endYear
    }

    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'get-cashflow', {
      method: "GET",
      headers: headers
    })
      .then((response) => response.json())
      .then((response) => {

        setProjects(response.project)
        setColumnName(response.ColumnName)
        setIsLoading(false);

        var dea = [];

        if (response.project.length != 0) {
          response.project.forEach(element => {
            const isNameExist = dea.some(item => item.projectType === element.projectType);
            if (isNameExist) {
            } else {
              dea.push(element);
            }
          })
        }


        setExpandedRows(dea);

        var arr2 = [];
        response.ColumnName.forEach(element => {

          var ar = [{
            field: element,
            name: response.RowName[0],

          },
          {
            field: element,
            name: response.RowName[1],

          }, {
            field: element,
            name: response.RowName[2],

          }
            , {
            field: element,
            name: response.RowName[3],

          }]

          var mergedArray = arr2.concat(ar);
          arr2 = mergedArray;

        });

        setRowName(arr2);

      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });

  }

  //Date Selection
  const selectDate = () => {
    const token = localStorage.getItem('authToken');

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    axios.get(Api.API_BASE_URL + 'get-startDate-endDate', { headers })
      .then((response) => {
        console.log('response', response.data.result);
        if (response.data.result.startDate && response.data.result.endDate) {
          // If dates are coming from the backend, set them
          setSelectOnStartDate(response.data.result.startDate);
          setSelectOnEndDate(response.data.result.endDate);
        } else {
          // If no dates are coming from the backend, set initial dates
          setSelectOnStartDate('2025-01-01'); // Initial start date
          setSelectOnEndDate('2025-12-31');   // Initial end date
        }
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
  }

  const lastYearSaleBodyTemplate = (col, rowname, rowData) => {
    return priceBodyTemplate(rowData[col.field][col.name]);
  };

  const showMonthIs = (myString) => {
    var myArray = myString.split(' ');

    var arr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",];
    var index = arr.indexOf(myArray[0]) + 1;

    var year = myArray[1];
    if (myArray[0] === 'Year') {
      return true;
      // index = 12;
    }

    var year = myArray[1];
    if (myArray[0] === 'QUARTER') {
      year = myArray[2]
      if (myArray[1] == '1') {
        index = 3;
      }
      if (myArray[1] == '2') {
        index = 6;
      }
      if (myArray[1] == '3') {
        index = 9;
      }
      if (myArray[1] == '4') {
        return true;
        // index = 12;
      }

    }

    let startDate = selectOnStartDate;
    let endDate = selectOnEndDate;

    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    
    const month = new Date(year + '-' + index + '-01');
    
    // Extract year and month from date1 and date2
    const year1 = date1.getFullYear();
    const month1 = date1.getMonth();

    const year2 = date2.getFullYear();
    const month2 = date2.getMonth();

    // Extract year and month from the target month
    const targetYear = month.getFullYear();
    const targetMonth = month.getMonth();

    // Check if the target month falls within the date range
    if (
      (targetYear > year1 || (targetYear === year1 && targetMonth >= month1)) &&
      (targetYear < year2 || (targetYear === year2 && targetMonth <= month2))
    ) {

      return true;
    } else {

      return false;
    }

    return false;
  }

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Product" frozen rowSpan={2} style={{ minWidth: '180px', textAlign: "center", borderRight: '3px solid gray' }} />
        <Column header="Start Date" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="Completion Date" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="Final Invoice Date" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="Months Leftt" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="Original Expected GP" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="Original GP Months" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="New Expected GP" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="Updated GP/Month" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="GP -/+ Term of Project/Month" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="GP -/+ Term of Project" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="% of GP Slippage" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="CONTRACT AMOUNT" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="PROJECTED COST - FEES" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="MARGIN %" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="ACTUALS TO DATE" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="ACTUALS - FEES" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="FEES TOTAL" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="FEES TO DATE" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="FEES LEFT" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="FEES P/M" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="DIRECT COST REMAINING" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="DIRECT COST P/M" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="FIXED PRICE" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="MONTHS" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="% COMPLETE" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="OVER UNDER BILLING" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="REVENUE EARNED TO DATE" rowSpan={2} style={{ minWidth: '150px', textAlign: "center" }} />
        <Column header="" rowSpan={2} style={{ minWidth: '150px', textAlign: "center", borderRight: "2px solid gray" }} />
        <Column header="" rowSpan={2} style={{ minWidth: '20px', textAlign: "center", backgroundColor: 'white', border: 'none', borderRight: "1px solid gray" }} />

        {columnName.map((row, i) => showMonthIs(row) ? (
          <Column key={i} header={row} colSpan={4} style={{ minWidth: '120px', textAlign: "center", borderRight: '3px solid black', backgroundColor: /QUARTER \d{1,2} \d{4}|Year \d{4}/.test(row) ? "#DDDDDD" : "", }} />

        ) : null)}
      </Row>

      <Row>
        {RowName.map((row, i) => showMonthIs(row.field) ? (
          <Column
            key={i}
            header={row.name}
            style={{
              minWidth: '120px',
              textAlign: "center",
              borderRight: row.name === 'Variance PM' ? '3px solid black' : 'none',
              padding: "2px",
            }}
          />
        ) : null)}
      </Row>

    </ColumnGroup>
  );

  const headerTemplate = (data) => {
    var t = data.projectType;

    if (data.projectType == "ZB FORECAST VS ACTULS") {
      t = "FORECAST VS ACTULS";
    }
    if (data.projectType == "ZD AJS PROJECTIONS") {
      t = "AJS PROJECTIONS";
    }
    if (data.projectType == "ZE DIVISION PROJECTIONS") {
      t = "DIVISION PROJECTIONS";
    }
    if (data.projectType == "ZC FSA PROJECTIONS") {
      t = "FSA PROJECTIONS";
    } if (data.projectType === 'Active Commercial') {
      t = 'Contract Commercial'
    } if (data.projectType === 'Active Custom Homes') {
      t = 'Contract Custom Homes'
    } if (data.projectType === 'Active Multi Family') {
      t = 'Contract Multi Family'
    } if (data.projectType === 'Active Renovations') {
      t = 'Contract Renovations'
    } if (data.projectType === 'Active Tenant Improvements') {
      t = 'Contract Tenant Improvements'
    }

    return (
      <React.Fragment>
        <td colSpan="1" className="no-horizontal-scroll  p-frozen-column myheader">
          <span style={{ overflowX: "hidden", whiteSpace: "nowrap", fontWeight: 'bold' }}>
            <i className="pi pi-circle-fill" style={{ color: "#" + data.projectTypeColorCode, }}></i>{t}
          </span>
        </td>
      </React.Fragment>
    );
  };

  const priceBodyTemplate = (rowData) => {
    if (rowData === '') {
      return '';
    }

    if (typeof rowData === 'string') {
      rowData = parseInt(rowData, 10);
    }

    const isNegative = rowData < 0; // Check if the value is negative

    return (
      <div style={{
        color: isNegative ? "red" : "black",
        // backgroundColor: isNegative ? "#fcd9d9" : "", 
        height: '36px',
        paddingTop: '8px',
        // border: isNegative ? '1px solid red' : '' 
      }}>

        {formatCurrency(rowData)}
      </div>
    );
  };

  const priceBodyPer = (rowData, allData) => {
    if (rowData === '') {
      return '';
    }
    let numberValue = Number(rowData); // Convert to a number if it's a string
    // Ensure rowData is a number after the conversion and it's not NaN
    if (isNaN(numberValue)) {
      console.error("rowData is not a number");
      return '';
    }
    const keyExists = allData.hasOwnProperty('no_of_project');
    // console.log(keyExists);
    if (keyExists) {
      numberValue = numberValue / allData.no_of_project;
    }
    const isNegative = numberValue < 0;
    return <div style={{
      color: isNegative ? "red" : "black",
      // backgroundColor: isNegative ? "#fcd9d9" : "",
      height: '36px',
      paddingTop: '8px',
      // border: isNegative ? '1px solid red' : ''
    }}>
      {numberValue.toFixed(2) + '%'}
    </div>;
  };


  const formatCurrency = (value) => {
    if (value == null) {
      return ''
    }
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };


  const DateViewTable = (value) => {
    var t = value;
    if (value == "0000-00-00") {
      t = '';
    }
    if (value != null) {
      let timestamp = new Date(value);



      if (!isNaN(timestamp.getTime())) {
        value = timestamp.toISOString().split('T')[0];
        return value;
      }
    }
    return t;
  }

  const handleOnSubmit = () => {
    if (startYear > endYear) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Start year should be less than end year', life: 3000 });
      return;
    } else {
      setIsLoading(true);
      StartDateAndEndDateSelect();
      getProject();
    }
  };

  const StartDateAndEndDateSelect = () => {
    const startDate = new Date(selectOnStartDate);
    const endDate = new Date(selectOnEndDate);

    if (startDate > endDate) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Start date should be before end date.' });
      return;
    }
    updateDateInBackend(selectOnStartDate, selectOnEndDate);

    localStorage.setItem('startYear', selectOnStartDate);
    localStorage.setItem('endYear', selectOnEndDate);
  }

  const updateDateInBackend = (startDate, endDate) => {
    setIsLoading(true);
    var _body = {
      startDate: startDate,
      endDate: endDate
    }
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'change-startDate-endDate/1', {
      method: "POST",
      body: JSON.stringify(_body),
      headers: headers
    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);
        getProject();
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });
  }

  const exportExcel = () => {
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(projects);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      saveAsExcelFile(excelBuffer, 'products');
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
          type: EXCEL_TYPE
        });

        module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    });
  };

  const renderHeader = () => {
    return (
      <div className="row flex align-items-center justify-content-between">
        <div className='col-4 '>
          <div className='flex items-center gap-2'>
            <button type="button" title='Download leads data in excel' style={{ cursor: 'pointer' }} onClick={exportExcel} data-pr-tooltip="XLS" outlined className="exce-download-button my-2" >
              <div className='flex items-center gap-2'>
                <FaFileExcel size={14} />
                <span> Download Excel </span>
              </div>
            </button>

            <button type="button" title='refresh' style={{ cursor: 'pointer' }} onClick={handleOnSubmit} outlined className="customSave-button my-2" >
              <div className='flex items-center gap-2'>
                <IoMdRefresh size={14} />
                <span> Refresh </span>
              </div>
            </button>

          </div>
          {/* <Button text rounded icon="pi pi-refresh" type="submit" title='refresh' onClick={handleOnSubmit} className='p-2 copySave-button ' /> */}
        </div>


        <div className='flex items-center gap-2' style={{ alignItems: 'center', marginRight: '10px' }}>
          <div className=''>
            <InputText
              type="date"
              className={classNames('p-2')}
              style={{ height: '30px', width: '100%', border: '1px solid #80808B', padding: '10px' }}
              value={selectOnStartDate}
              onChange={(e) => setSelectOnStartDate(e.target.value)}
            />
          </div>

          <div className=''>
            <InputText
              type="date"
              className={classNames('p-2')}
              style={{ height: '30px', width: '100%', border: '1px solid #80808B', padding: '10px' }}
              value={selectOnEndDate}
              onChange={(e) => setSelectOnEndDate(e.target.value)}
            />
          </div>

          <div className=''>
            <button type="submit" title='sabmit the Date' style={{ cursor: 'pointer' }} onClick={handleOnSubmit} outlined className="customSave-button my-2" >
              <div className='flex items-center gap-2'>
                {/* <IoMdRefresh  size={14} /> */}
                <span> Save </span>
              </div>
            </button>
            {/* <Button label="Submit" type="submit" title='sabmit the Date' onClick={handleOnSubmit} className='p-2 customSave-button' /> */}
          </div>
        </div>

      </div>
    );
  };

  const rowClass = (data) => {
    return {
      'bg-gray-300': data.projectType === 'TOTAL' || data.projectType === 'ZC FSA PROJECTIONS' || data.projectType === 'ZB FORECAST VS ACTULS' || data.projectType === 'ZD AJS PROJECTIONS' || data.projectType === 'ZE DIVISION PROJECTIONS'
    };
  };

  // const getMonthLeft = (data, complationDate) => {
  //   const completionDate = new Date(complationDate);

  //   // Get the current date
  //   const today = new Date();

  //   // Extract year and month components
  //   const todayYear = today.getFullYear();
  //   const todayMonth = today.getMonth() + 1; // Months are zero-based, so add 1

  //   const completionYear = completionDate.getFullYear();
  //   const completionMonth = completionDate.getMonth() + 1; // Months are zero-based, so add 1

  //   // Compare year and month components
  //   if (
  //     completionYear < todayYear ||
  //     (completionYear === todayYear && completionMonth < todayMonth)
  //   ) {
  //     return "";
  //   }
  //   return data;

  // }

  // const dateTimeOfFirstDay = (date) => {
  //   var myArray = date.split('-');
  //   if (myArray.length > 1) {
  //     return myArray[0] + '-' + myArray[1] + '-01';
  //   }
  // }

  return (
    <>
      <div className="">
        <Toast ref={toast} />
        <div className='m-0'>
          {renderHeader()}
        </div>
        <div className="fd">
          {isLoading ? (
            <div className="loading-spinner">
              Loading...
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="p-2">

              <DataTable
                //virtualScrollerOptions={{ itemSize: 46 }} 
                value={projects}
                rowClassName={rowClass}
                rowGroupMode="subheader"
                groupRowsBy="projectType"
                showGridlines
                expandableRowGroups={true}
                rowGroupHeaderTemplate={headerTemplate}
                sortMode="single"
                sortField="projectType"
                sortOrder={0}
                scrollable
                size="small"
                selectionMode="single" selection={selectedProduct} onSelectionChange={(e) => setSelectedProduct(e.value)}
                scrollHeight="80vh"
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                headerColumnGroup={headerGroup}
                tableStyle={{ minWidth: "50rem", cursor: "pointer", overflow: "auto", borderCollapse: 'separate', borderSpacing: '0' }}

              >
                {/* <Column field="projectName" style={{ minWidth: "300px", borderRight: '3px solid gray' }} frozen bodyClassName="cashPad" /> */}
                <Column field="projectName" style={{ minWidth: "300px", borderRight: '3px solid gray' }} frozen bodyClassName="cashPad"
                  body={(e) =>
                    e.projectName === 'Active Commercial' ? 'Contract Commercial' :
                      e.projectName === 'Active Custom Homes' ? 'Contract Custom Homes' :
                        e.projectName === 'Active Multi Family' ? 'Contract Multi Family' :
                          e.projectName === 'Active Renovations' ? 'Contract Renovations' :
                            e.projectName === 'Active Tenant Improvements' ? 'Contract Tenant Improvements' :
                              e.projectName === 'Active Service & Maintenance' ? 'Contract Service & Maintenance' :
                                e.projectName}
                />


                <Column
                  field="actual_start_date_pm"
                  style={{ minWidth: "120px", textAlign: "center" }} body={(e) => DateViewTable(e.actual_start_date_pm)}
                />

                <Column
                  field="actual_complation_date_pm"
                  style={{ minWidth: "120px", textAlign: "center" }} body={(e) => DateViewTable(e.actual_complation_date_pm)}
                />

                <Column
                  field="final_complation_date"
                  style={{ minWidth: "120px", textAlign: "center" }} body={(e) => DateViewTable(e.final_complation_date)}
                />

                <Column
                  field="monthLeft"
                  style={{ minWidth: "180px", textAlign: "center" }}
                />

                <Column
                  field="orig_expected_gp"
                  style={{ minWidth: "180px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.orig_expected_gp)}
                />
                <Column
                  field="orig_gp_month"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.orig_gp_month)}
                />
                <Column
                  field="newExpectedGP"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.newExpectedGP)}
                />
                <Column
                  field="updatedGPMonth"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.updatedGPMonth)}
                />
                <Column
                  field="gpTermofProjectperMonth"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.gpTermofProjectperMonth)}
                />
                <Column
                  field="gpTermofProject"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.gpTermofProject)}
                />
                <Column
                  field="perofGPSlippage"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyPer(e.perofGPSlippage, e)}
                />
                <Column
                  field="contract_amount"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.contract_amount)}
                />
                <Column
                  field="projectCostFees"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.projectCostFees)}
                />
                <Column
                  field="margin"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyPer(e.margin, e)}
                />
                <Column
                  field="actuals_to_date"
                  body={(e) => priceBodyTemplate(e.actuals_to_date)}
                  style={{ minWidth: "120px", textAlign: "center" }}
                />
                <Column
                  field="actuals_fee"
                  body={(e) => priceBodyTemplate(e.actuals_fee)}
                  style={{ minWidth: "120px", textAlign: "center" }}
                />

                <Column
                  field="feesTotal"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.feesTotal)}
                />
                <Column
                  field="feesToDate"
                  body={(e) => priceBodyTemplate(e.feesToDate)}
                  style={{ minWidth: "120px", textAlign: "center" }}
                />
                <Column
                  field="feesLeft"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.feesLeft)}
                />
                <Column
                  field="fessPerMonth"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.fessPerMonth)}
                />
                <Column
                  field="directCostRemaining"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.directCostRemaining)}
                />
                <Column
                  field="directcostperMonth"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.directcostperMonth)}
                />
                <Column
                  field="fixedPrice"
                  body={(e) => priceBodyTemplate(e.fixedPrice)}
                  style={{ minWidth: "120px", textAlign: "center" }}
                />
                <Column
                  field="fixedMonth"
                  style={{ minWidth: "120px", textAlign: "center" }}
                />
                <Column
                  field="complete"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyPer(e.complete, e)}
                />
                <Column
                  field="overUnderBilling"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.overUnderBilling)}
                />
                <Column
                  field="revenueEarnedToDate"
                  style={{ minWidth: "120px", textAlign: "center" }}
                  body={(e) => priceBodyTemplate(e.revenueEarnedToDate)}
                />
                <Column
                  field="overallPersanatage"
                  style={{
                    minWidth: "120px",
                    textAlign: "center",
                    borderRight: "1px solid gray",
                  }}
                  body={(e) => priceBodyPer(e.overallPersanatage, e)}
                />
                <Column
                  field=""
                  style={{
                    minWidth: "20px",
                    textAlign: "center",
                    backgroundColor: "white",
                    border: "none",
                    borderRight: "1px solid gray"
                  }}
                />

                {RowName.map((col, i) => showMonthIs(col.field) ? (
                  <Column
                    key={i}
                    field={col.name}
                    body={(e) => lastYearSaleBodyTemplate(col, "Fee PM", e)}
                    style={{
                      textAlign: "center",
                      borderRight: col.name === 'Variance PM' ? '3px solid black' : 'none',
                      // backgroundColor:'red'
                      padding: "1px"
                    }}
                  />

                ) : null)}
              </DataTable>
            </div>
          )}


        </div>
      </div>
    </>
  );
}

// export default Cashfloww
export default React.memo(Cashfloww);